import { Link } from "react-router-dom";
import { ArrowRight, ListChecks, CalendarHeart } from "lucide-react";
import { IMAGES } from "@/lib/site";
import { Reveal, ParallaxImage } from "@/components/motion-primitives";
import TransportTeaser from "@/components/TransportTeaser";

export default function GuestToolsPromo() {
  return (
    <section className="mx-auto max-w-[1440px] px-6 py-24 lg:px-10 lg:py-32" data-testid="guest-tools-promo">
      <div className="grid gap-8 lg:grid-cols-2">
        <Reveal className="h-full">
          <div className="relative flex h-full min-h-[420px] flex-col justify-end overflow-hidden bg-navy text-ivory">
            <ParallaxImage src={IMAGES.moonGate} alt="A Bermuda moongate" className="absolute inset-0" speed={0.08} />
            <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-navy/10" />
            <div className="relative z-10 p-9 lg:p-12">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-bermuda/20 text-bermuda">
                <ListChecks size={17} strokeWidth={1.5} />
              </span>
              <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.3em] text-bermuda">For Our Guests</p>
              <h3 className="mt-4 max-w-md font-serif text-3xl font-light leading-tight sm:text-4xl">
                How much of Bermuda can you experience?
              </h3>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-ivory/75">
                Take on The Bermuda Bucket List Challenge during your stay and see how many island experiences you can complete before checkout.
              </p>
              <Link
                to="/bermuda-bucket-list"
                data-testid="home-bucket-list-btn"
                className="group mt-7 inline-flex items-center gap-2.5 bg-bermuda px-7 py-4 text-[11px] font-semibold uppercase tracking-[0.18em] text-navy transition-colors hover:bg-ivory"
              >
                Start the Challenge
                <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </Reveal>

        <div className="flex flex-col gap-8">
          <TransportTeaser />
          <Reveal delay={0.1}>
            <div className="flex h-full flex-col border border-navy/10 bg-sand-light p-8 transition-all duration-500 hover:border-bermuda" data-testid="plan-stay-teaser">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-bermuda-dark">
                <CalendarHeart size={17} strokeWidth={1.5} />
              </span>
              <h3 className="mt-5 font-serif text-[22px] leading-tight text-navy">Plan Your Bermuda Stay</h3>
              <p className="mt-3 flex-1 text-[13px] leading-relaxed text-navy/60">
                Who you're with, what you love, where you're staying — we'll build your personal mini-itinerary around your corner of the island.
              </p>
              <Link to="/guest-tools/plan-your-stay" data-testid="plan-stay-teaser-btn" className="group mt-6 inline-flex w-fit items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-navy transition-colors hover:text-bermuda-dark">
                Plan My Stay <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
